/**
 * 权限码，与后端 `TickbirdPermissions` 一一对应（docs/identity-and-authz.md §6）。
 *
 * 前端只用它做菜单与按钮显隐；真正的判权在服务端两段完成
 * （Controller 功能闸门 + Application 范围判定），前端隐藏不等于安全。
 */
export const Permissions = {
  tickets: {
    view: "Tickbird.Tickets",
    create: "Tickbird.Tickets.Create",
    reply: "Tickbird.Tickets.Reply",
    update: "Tickbird.Tickets.Update",
    changeStatus: "Tickbird.Tickets.ChangeStatus",
    assign: "Tickbird.Tickets.Assign",
    claim: "Tickbird.Tickets.Claim",
    manageParticipants: "Tickbird.Tickets.Participants.Manage",
    scopeAll: "Tickbird.Tickets.Scope.All",
    ai: {
      read: "Tickbird.Tickets.Ai.Read",
      generate: "Tickbird.Tickets.Ai.Generate",
      feedback: "Tickbird.Tickets.Ai.Feedback",
    },
  },
  projects: {
    view: "Tickbird.Projects",
    create: "Tickbird.Projects.Create",
    update: "Tickbird.Projects.Update",
    delete: "Tickbird.Projects.Delete",
  },
  categories: {
    view: "Tickbird.Categories",
    create: "Tickbird.Categories.Create",
    update: "Tickbird.Categories.Update",
    delete: "Tickbird.Categories.Delete",
  },
  customers: {
    view: "Tickbird.Customers",
    create: "Tickbird.Customers.Create",
    update: "Tickbird.Customers.Update",
  },
  teams: {
    view: "Tickbird.Teams",
    create: "Tickbird.Teams.Create",
    update: "Tickbird.Teams.Update",
    delete: "Tickbird.Teams.Delete",
    manageMembers: "Tickbird.Teams.Members.Manage",
  },
  agents: {
    view: "Tickbird.Agents",
    create: "Tickbird.Agents.Create",
    update: "Tickbird.Agents.Update",
    manageRoles: "Tickbird.Agents.Roles.Manage",
  },
  routingRules: {
    view: "Tickbird.RoutingRules",
    create: "Tickbird.RoutingRules.Create",
    update: "Tickbird.RoutingRules.Update",
    delete: "Tickbird.RoutingRules.Delete",
  },
  settings: {
    view: "Tickbird.Settings",
    manageAi: "Tickbird.Settings.Ai.Manage",
  },
  reports: {
    view: "Tickbird.Reports.View",
  },
} as const;
